var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 76,
    viewBox: "0 0 146 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.272 56.4007C117.33 55.0404 115.795 54.2382 114.156 54.2382H99.9259L95.4615 47.6811C94.5198 46.286 92.9503 45.4838 91.2761 45.4838H70.0005L67.9078 37.6362C67.7682 37.1131 67.2451 36.7991 66.7219 36.9387L63.8619 37.706C63.3387 37.8455 63.0248 38.3687 63.1643 38.8918L68.2914 58.0051L63.0946 68.6429L67.4892 70.8054L73.0697 59.2956C73.1395 59.1212 73.2092 58.9468 73.2441 58.7724H114.121C114.261 58.7724 114.4 58.8421 114.505 58.9817L124.341 73.4212L128.073 70.8751L118.272 56.4007ZM91.2761 48.2043C92.0086 48.2043 92.7061 48.588 93.1247 49.1809L96.5079 54.1685H72.3373L70.7329 48.1694H91.2761V48.2043Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.385 74.2585H7.25467C17.6832 68.0502 31.5996 63.4463 45.5858 63.6555C62.2924 63.8997 78.3364 67.7712 82.6961 69.8987C94.6593 69.1663 109.866 66.0273 117.818 66.2714C124.585 66.5155 134.42 68.3292 140.385 74.2585Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 74.2585H140.385H7.25466H0",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 74.2585H140.385H7.25466H0",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0846 67.6316C52.3521 67.6316 51.6895 67.1084 51.5499 66.376L39.0807 1.88043C38.9063 1.04335 39.4644 0.206277 40.3363 0.0318861C41.1734 -0.142505 42.0105 0.415546 42.1849 1.2875L54.6541 65.7481C54.8285 66.5852 54.2704 67.4223 53.3985 67.5967C53.259 67.6316 53.1892 67.6316 53.0846 67.6316Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1228 34.7414C32.1577 34.5321 32.2274 34.3577 32.2972 34.1484C32.3321 34.4623 32.3321 34.7762 32.367 35.0901C32.2972 34.9506 32.1926 34.846 32.1228 34.7414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8509 29.3003C59.8161 29.3352 59.8161 29.405 59.8161 29.4398C59.7812 29.3352 59.7463 29.2306 59.7114 29.0911C59.7463 29.1608 59.8161 29.2306 59.8509 29.3003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.651 30.3044C114.316 30.3044 119.719 24.9014 119.719 18.2365C119.719 11.5717 114.316 6.1687 107.651 6.1687C100.987 6.1687 95.5836 11.5717 95.5836 18.2365C95.5836 24.9014 100.987 30.3044 107.651 30.3044Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0306 71.1544C28.3908 69.0617 31.216 69.55 32.3669 69.9685",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2136 68.9917C49.0736 67.2129 52.8055 68.5732 53.0846 69.9334",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0024 72.3751C58.4907 71.6776 59.6068 71.1544 60.3392 71.6427",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.344 71.9216C106.239 70.9799 106.378 71.5728 107.111 71.9216",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.145 71.1542C113.459 70.5961 114.993 70.8403 114.993 70.8403",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9288 19.6393C78.999 18.1744 75.581 17.6164 72.0932 18.2791C66.0592 19.3952 61.4553 23.7898 59.8509 29.3006C59.816 29.3354 59.816 29.4052 59.816 29.4401C59.7812 29.3354 59.7463 29.2308 59.7114 29.0913C56.2236 24.6618 50.4338 22.2203 44.4697 23.3364C38.5055 24.4176 33.9713 28.7425 32.2972 34.1486C32.332 34.4625 32.332 34.7764 32.3669 35.0903C32.2972 34.9857 32.1925 34.8462 32.1228 34.7416C28.6698 29.9632 22.7057 27.3474 16.5322 28.4635C13.2886 29.0564 10.4286 30.6259 8.26611 32.7884C12.033 17.6861 24.3101 5.37415 40.6331 2.4095C57.0955 -0.624897 73.0697 6.66464 81.9288 19.6393Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7114 29.091C56.2236 24.6615 50.4338 22.22 44.4696 23.3361C38.5055 24.4174 33.9713 28.7423 32.2972 34.1484C30.902 16.9534 34.1457 3.5951 40.6679 2.40925C47.1553 1.22339 54.8982 12.5588 59.7114 29.091Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/NoNotifications.d27848be224f6b4f0accf51ea27b46c1.svg";
export { ForwardRef as ReactComponent };